<template>
<section>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h2>Thanks for registration</h2>
                <h3>You will receive a call from our expert within the next 24 hours and receive your free stock report.</h3>
                <form @submit.prevent="saveData">
                    <div class="question_card">
                        <p class="black--text">In order to serve you better and provide you personalized guidance, kindly fill out this brief questionnaire:</p>
                        <v-radio-group label="Choose your monthly investment budget" required v-model="budget">
                            <v-radio label="0 - 20,000 INR" value="0 - 20,000 INR"></v-radio>
                            <v-radio label="20,000 - 50,000 INR" value="20,000 - 50,000 INR"></v-radio>
                            <v-radio label="1,00,000 TO 5,00,000 INR" value="1,00,000 TO 5,00,000 INR"></v-radio>
                            <v-radio label="Above 5,00,000 INR" value="Above 5,00,000 INR"></v-radio>
                        </v-radio-group>
                    </div>
                    <div class="question_card">
                        <v-radio-group label="Have you ever invested in stocks before:" required v-model="investment">
                            <v-radio label="Yes" value="yes"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                        </v-radio-group>
                    </div>
                    <div class="question_card">
                        <v-radio-group label="Choose your trading strategy" required v-model="strategy">
                            <v-radio label="Intra-day trader" value="Intra-day trader"></v-radio>
                            <v-radio label="Long term Investor" value="Long term Investor"></v-radio>
                            <v-radio label="Both" value="Both"></v-radio>
                        </v-radio-group>
                    </div>
                    <v-btn color="success" type="submit" :disabled="!strategy || !investment || !budget"> Submit </v-btn>
                </form>
            </div>
        </div>
    </div>
</section>

</template>

<script>

export default {
    name: "Welcome",
    data(){
        return{
            budget: '',
            investment: '',
            strategy: ''
        }
    },
    methods: {
        saveData(){
            const url = this.$route.query.newsletter ? 'https://api.steinhq.com/v1/storages/64949ca4eced9b09e9d9d575' :'https://api.steinhq.com/v1/storages/63f34f2aeced9b09e9c00cab'
            const sheet = this.$route.query.newsletter ? 'Sheet4' :'Sheet2'      
            
            const name =  window.localStorage.getItem('name') ||  this.$route.query.name
            const email =  window.localStorage.getItem('email') ||  this.$route.query.email
            const phone =  window.localStorage.getItem('phone') ||  this.$route.query.phone

             const store = new SteinStore(
                    url
                );
                store
                    .append(sheet, [
                    {
                        name,
                        ...(this.$route.query.newsletter ? {email} : { phone}),
                        budget: this.budget,
                        investment: this.investment,
                        strategy: this.strategy
                        
                    }
                    ])
                    .then(res => {
                       this.$toasted.success("Data saved successfully", {
                            duration: 2000,
                            position: "bottom-right"
                        });
                    })
                    .catch(err => {
                         this.$toasted.error(err, {
                            duration: 2000,
                            position: "bottom-right"
                        });
                    });
        }
    }
}

</script>


<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700;800&family=Nunito:wght@300;400;500;600;700&display=swap');

section{
    // font-family: 'Nunito';
    h2{
        
        font-weight: 700;
        font-size: 50px;
        margin-top: 80px;
    }
    h3{
        font-weight: 600;
        font-size: 25px;
        text-align: left;
    }
    p{
        font-size: 18px;
        font-weight: 700;
    }
    background: #F2F2F2;

    .question_card{
        background: #fff;
        padding: 20px;
        margin: 20px 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Welcome.vue